import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {AccountHeader} from './AccountsHeader'
import {Overview} from './Overview/Overview'
import TeamList from './SubAccounts/TeamList'
import BusinessNameList from './BusinessName/BusinessNameList'
import CustomNumberList from './CustomNumber/CustomNumberList'
import DedicatedNumberList from './DedicatedNumber/DedicatedNumberList'
import BillingAddress from './Billing/BillingAddress'
import {BillingTable} from './Billing/BillingPurchaseTable'
import FrontendSigninMethod from './Frontend_Setting/FrontendSigninMethod'
import FrontendUserProfile from './Frontend_Setting/FrontendUserProfile'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import ApiKey from './ApiKeys/ApiKey'
import NotificationList from './Notifications/list'
import CreditHistoryTable from './BalanceHistory'
import {BillingPurchaseDnTable} from './Billing/BillingPurchaseDnTable'
import Referral from './Referral/Referral'
import {useSelector} from 'react-redux'
import {
  getAllUserDetails,
  getDefaultRegion,
  getIsDefaultRegion,
} from './Overview/OverviewSlice/UserDetailsSlice'
import React, {useEffect, useState} from 'react'
import {SmppStatus} from '../../../../services/cellcast.v2.types'
import SmppCard from './Smpp'
import {GetCurrentData} from '../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../_metronic/helpers'
import {REGION} from '../../../Utils/Constant/ConstantForWebsite'
import BounceNotification from './Frontend_Setting/BounceNotification'
import UnsubscribeNotification from './Frontend_Setting/UnsubscribeNotification'
import NewBiteNotification from './Frontend_Setting/NewBiteNotification'
import VoiceNotification from './Frontend_Setting/VoiceNotification'

const AccountsPage = () => {
  const userData: any = useSelector(getAllUserDetails)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const currentRegion = useSelector(getDefaultRegion)
  const isSmppServerActive = userData?.smppStatus && userData?.smppStatus === SmppStatus.Active
  const currentUser = GetCurrentData()
  const [showModalDedicatedNumber, setShowModalDedicatedNumber] = useState(false)
  const [showModalCustomBussines, setShowModalCustomBussines] = useState(false)
  const [showModalCustomNumber, setShowModalCustomNumber] = useState(false)
  const [isShowCredit, setIsShowCredit] = useState(true)
  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route index element={<Navigate to='/accounts/overview' replace={true} />} />
          <Route
            path='overview'
            element={
              <>
                <Overview />
              </>
            }
          />

          <Route
            path='settings'
            element={
              <>
                <FrontendUserProfile />
                <div className='mt-10'></div>
                <BounceNotification />
                <div className='mt-10'></div>
                <UnsubscribeNotification />
                <div className='mt-10'></div>
                <VoiceNotification />
                <div className='mt-10'></div>
                <NewBiteNotification />
                <div className='mt-10'></div>
                <FrontendSigninMethod />
              </>
            }
          />

          <Route
            path='billing'
            element={
              <>
                {AuthenticateUser('see-credit-history') && <BillingTable />}
                <div className='mt-10'></div>

                {AuthenticateUser('see-credit-history') && <BillingPurchaseDnTable />}
                {[REGION.US, REGION.UK].includes(currentRegion) || isDefaultRegion ? (
                  <>
                    <div className='mt-10'></div>
                    {AuthenticateUser('create-auto-popup-setting') && <BillingAddress />}
                  </>
                ) : null}
              </>
            }
          />

          <Route
            path='referral'
            element={
              <>
                <div className='mt-10'></div>
                <Referral />
              </>
            }
          />

          <Route
            path='balance-history'
            element={
              <>
                <div className='mt-10'></div>
                <CreditHistoryTable />
              </>
            }
          />

          <Route
            path={`sender-id's`}
            element={
              <>
                {[REGION.US, REGION.UK].includes(currentRegion) || isDefaultRegion ? (
                  <>
                    {AuthenticateUser('show-dedicated-number') && (
                      <DedicatedNumberList
                        setShowCredit={setIsShowCredit}
                        showModalNew={showModalDedicatedNumber}
                        setShowModalNew={setShowModalDedicatedNumber}
                        onClickLearnMore={() => {}}
                      />
                    )}
                  </>
                ) : null}

                {[REGION.UK].includes(currentRegion) || isDefaultRegion ? (
                  <>
                    {' '}
                    <div className='mt-10'></div>
                    {AuthenticateUser('show-business-name') && (
                      <BusinessNameList
                        showModalNewBusiness={showModalCustomBussines}
                        setShowModalNewBusiness={setShowModalCustomBussines}
                        onClickLearnMore={() => {}}
                      />
                    )}
                  </>
                ) : null}
                {isDefaultRegion ? (
                  <>
                    <div className='mt-10'></div>
                    {AuthenticateUser('show-custom-numbers') && (
                      <CustomNumberList
                        showModalNew={showModalCustomNumber}
                        setShowModalNew={setShowModalCustomNumber}
                        onClickLearnMore={() => {}}
                      />
                    )}
                  </>
                ) : null}
              </>
            }
          />

          {AuthenticateUser('list-sub-accounts') && (
            <Route
              path='team-list'
              element={
                <>
                  <TeamList />
                </>
              }
            />
          )}
          {true && (
            <Route
              path='api-keys'
              element={
                <>
                  <ApiKey />
                </>
              }
            />
          )}

          {isSmppServerActive && (
            <Route
              path='smpp'
              element={
                <>
                  <SmppCard />
                </>
              }
            />
          )}

          <Route
            path='notifications'
            element={
              <>
                <NotificationList />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default AccountsPage
